import './POSIconButtonWithTooltip.less';
import React from 'react';
import {
  POSIconButton,
  Props as ButtonProps,
} from '../POSIconButton/POSIconButton';
import { Popup } from 'semantic-ui-react';
import { PopupPositionType, PopupSizeType } from '../POSIconWithTooltip';

export interface Props extends ButtonProps {
  tooltip: string;
  tooltipClassName?: string;
  tooltipSize?: PopupSizeType;
  tooltipPosition?: PopupPositionType;
}

export const POSIconButtonWithTooltip = (props: Props) => {
  return (
    <React.Fragment>
      <Popup
        content={props.tooltip}
        className={props.tooltipClassName}
        position={props.tooltipPosition}
        size={props.tooltipSize}
        trigger={
          <div className="icon-button-wrapper">
            <POSIconButton {...props} />
          </div>
        }
      />
    </React.Fragment>
  );
};
